import styled from "styled-components";
import { fontFamilies, fontSizes } from "components/shared/tokens/typography";
import red from "components/shared/tokens/color/red";

export const SuccessBackdrop = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(20, 25, 30, 0.76);
  backdrop-filter: blur(5px);
  font-family: ${fontFamilies.regular};
`;

export const Dialog = styled.div`
  width: 100%;
  max-width: 270px;
  overflow: hidden;
  border-radius: 22px;
  background: #ffffff;
`;

export const DialogContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 18px 21px;
`;

export const SuccessIcon = styled.div`
  width: 66px;
  height: 66px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #e8faed;

  svg {
    width: 31px;
    height: 31px;
    padding: 6px;
    border-radius: 50%;
    background: #36ba60;
    color: #ffffff;
    stroke-width: 2.5;
  }
`;

export const SuccessTitle = styled.h1`
  margin: 16px 0 0;
  color: #1c1c1c;
  font-family: ${fontFamilies.semiBold};
  font-size: ${fontSizes.z300};
  line-height: 1.35;
  text-align: center;
`;

export const DialogAction = styled.button`
  width: 100%;
  min-height: 46px;
  padding: 11px 16px;
  border: 0;
  border-top: 1px solid #e6e8ed;
  background: #ffffff;
  color: ${red.z500};
  font-family: ${fontFamilies.regular};
  font-size: ${fontSizes.z200};
  cursor: pointer;

  &:active {
    background: #f8f8f8;
  }
`;
